import { Container, Row, Col } from "react-bootstrap";
// import logo from "../assets/img/logo.svg";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col size={12} sm={6} className="text-white fw-bold fs-3">
            {/* <img src={logo} alt="Logo" /> */}
            RAKHMAT KHAIDIR
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon mt-5">
              <a href="https://www.linkedin.com/in/rakhmat-khaidir-966893194/" rel="noreferrer" target="_blank"><img src={navIcon1} alt="Icon" /></a>
              <a href="https://web.facebook.com/rakhmat.khaidir.90/" rel="noreferrer" target="_blank"><img src={navIcon2} alt="Icon" /></a>
              <a href="https://www.instagram.com/rkhaidir/?hl=id" rel="noreferrer" target="_blank"><img src={navIcon3} alt="Icon" /></a>
            </div>
            <p>Copyright 2022. All Rights Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
